import { Row as RowPrime } from 'primereact/row'

const RowColumnGroup = RowPrime

export default RowColumnGroup
